export const dataGameAppPosts = [
    {
      id: 1,
      imagePost: "https://cdn.tgdd.vn/2022/04/content/Gunny-Origin-600x360.jpg",
      imgTitle:
        "https://cdn.tgdd.vn/GameApp/2/276446/Screentshots/gunny-origin-song-lai-cam-giac-ga-game-ban-sung-toa-do-276446-logo-07-04-2022.png",
      titlePost:
        "Gunny Origin - Sống Lại Cảm Giác Gà: game bắn súng tọa độ Gunny",
    },
    {
      id: 1,
      imagePost:
        "https://cdn.tgdd.vn/2022/01/content/vua-hai-tac-cmn-600x360.jpg",
      imgTitle: "https://cdn.tgdd.vn/2022/01/GameApp/icon-200x200.jpg",
      titlePost: "Vua Hải Tặc CMN - Tái hiện thế giới One Piece siêu chân thật",
    },
    {
      id: 1,
      imagePost: "https://cdn.tgdd.vn/2021/08/content/Untitled-2-600x360.jpg",
      imgTitle:
        "https://cdn.tgdd.vn/GameApp/3/249053/Screentshots/3q-cmn--choi-met-nghi-249053-logo-16-08-2021.png",
      titlePost: "3Q CMN - Game thẻ tướng Tam Quốc thế hệ mới",
    },
    {
      id: 2,
      imagePost: "https://cdn.tgdd.vn/2021/05/content/Counterside-600x360.jpg",
      imgTitle:
        "https://cdn.tgdd.vn/GameApp/2/239741/Screentshots/counter-side-sieu-pham-game-the-tuong-anime-239741-logo-20-05-2021.png",
      titlePost: "Counter: Side - Siêu phẩm game thẻ tướng Anime",
    },
    {
      id: 2,
      imagePost: "https://cdn.tgdd.vn/2021/04/content/thumb-600x360-1.jpg",
      imgTitle:
        "https://cdn.tgdd.vn/GameApp/3/237932/Screentshots/tan-omg3q-vng-237932-logo-27-04-2021.png",
      titlePost: "Tân OMG3Q VNG - Game đấu tướng Tam Quốc thế hệ mới",
    },
    {
      id: 2,
      imagePost:
        "https://cdn.tgdd.vn/2021/04/content/vltk-1-mobile-600x360-1.jpg",
      imgTitle:
        "https://cdn.tgdd.vn/GameApp/2/236384/Screentshots/vo-lam-truyen-ky-1-mobile-236384-logo-15-04-2021.png",
      titlePost: "Võ Lâm Truyền Kỳ 1 Mobile - Huyền thoại game kiếm hiệp",
    },
  ];
  export const dataGameAppPostsApp = [
    {
      id: 1,
      imagePost: "https://cdn.tgdd.vn/2021/02/content/meetfeat-600x360.jpg",
      imgTitle:
        "https://cdn.tgdd.vn/GameApp/3/228059/Screentshots/google-meet-app-hop-truc-tuyen-hoc-online-khong-gioi-228059-logo-01-09-2020.png",
      titlePost:
        "Google Meet: App họp trực tuyến, học online không giới hạn người tham gia",
    },
    {
      id: 2,
      imagePost: "https://cdn.tgdd.vn/2021/02/content/zoomfeat-600x360.jpg",
      imgTitle:
        "https://cdn.tgdd.vn/GameApp/3/228059/Screentshots/google-meet-app-hop-truc-tuyen-hoc-online-khong-gioi-228059-logo-01-09-2020.png",
      titlePost:
        "Google Meet: App họp trực tuyến, học online không giới hạn người tham gia",
    },
    {
      id: 3,
      imagePost:
        "https://cdn.tgdd.vn/2020/04/content/PicsArtPhotoEditor1-600x360-1.jpg",
      imgTitle:
        "https://cdn.tgdd.vn/GameApp/3/228059/Screentshots/google-meet-app-hop-truc-tuyen-hoc-online-khong-gioi-228059-logo-01-09-2020.png",
      titlePost:
        "Google Meet: App họp trực tuyến, học online không giới hạn người tham gia",
    },
    {
      id: 4,
      imagePost: "https://cdn.tgdd.vn/2020/04/content/instagram-600x360.jpg",
      imgTitle:
        "https://cdn.tgdd.vn/GameApp/3/228059/Screentshots/google-meet-app-hop-truc-tuyen-hoc-online-khong-gioi-228059-logo-01-09-2020.png",
      titlePost:
        "Google Meet: App họp trực tuyến, học online không giới hạn người tham gia",
    },
    {
      id: 5,
      imagePost: "https://cdn.tgdd.vn/2020/03/content/thum-600x360-5.jpg",
      imgTitle:
        "https://cdn.tgdd.vn/GameApp/3/228059/Screentshots/google-meet-app-hop-truc-tuyen-hoc-online-khong-gioi-228059-logo-01-09-2020.png",
      titlePost:
        "Google Meet: App họp trực tuyến, học online không giới hạn người tham gia",
    },
    {
      id: 6,
      imagePost: "https://cdn.tgdd.vn/2020/03/content/tik-600x360.jpg",
      imgTitle:
        "https://cdn.tgdd.vn/GameApp/3/228059/Screentshots/google-meet-app-hop-truc-tuyen-hoc-online-khong-gioi-228059-logo-01-09-2020.png",
      titlePost:
        "Google Meet: App họp trực tuyến, học online không giới hạn người tham gia",
    },
  ];

  
  export const dataHoidap = [
    {
      id: 1,
      img: "https://cdn.tgdd.vn/hoi-dap/1448087/Thumbnail/cuong-sao-noi-voi-loat-deal-samsung-galaxy-watch4-giam-thumb.jpg",
      title: "Cưỡng sao nổi với loạt DEAL Samsung Galaxy Watch4 giảm tới 3 triệu",
      chude: "Thiết bị thông minh",
    },
    {
      id: 1,
      img: "https://cdn.tgdd.vn/hoi-dap/1450300/Thumbnail/cach-go-so-dien-thoai-tren-facebook-sieu-nhanh-chong-ban-thumb-1.jpg",
      title: "Cách gỡ số điện thoại trên Facebook siêu nhanh chóng bạn nên thử",
      chude: "Thiết bị thông minh",
    },
  ];
  export const dataHoidap2 = [
    {
      id: 1,
      img: "https://cdn.tgdd.vn/hoi-dap/1449961/Thumbnail/top-5-dong-ho-thong-minh-befit-duoi-1-trieu-ma-ban-nen-so_thumbnail.jpg",
      title: "TOP 5 đồng hồ thông minh BeFit dưới 1 triệu mà bạn nên sở hữu ngay",
      chude: "Đồng hồ - Mắt kính",
    },
    {
      id: 2,
      img: "https://cdn.tgdd.vn/hoi-dap/1449826/Thumbnail/top-5-dong-ho-thong-minh-duoi-1-trieu-ma-ban-nen-suu-tam-thumb02.jpg",
      title: "TOP 5 đồng hồ thông minh dưới 1 triệu mà bạn nên sưu tầm ngay",
      chude: "Thủ thuật văn phòng",
    },
    {
      id: 3,
      img: "https://cdn.tgdd.vn/hoi-dap/1449543/Thumbnail/tin-vui-loat-dong-ho-thong-minh-moi-ra-mat-tang-kem-qua-thumb.jpg",
      title:
        "TIN VUI: Loạt đồng hồ thông minh mới ra mắt tặng kèm quà tai nghe xịn",
      chude: "Thiết bị thông minh",
    },
    {
      id: 4,
      img: "https://cdn.tgdd.vn/hoi-dap/1449579/Thumbnail/dai-tiec-deal-hot-sam-ngay-dong-ho-thong-minh-uu-dai-qua-Thumb.jpg",
      title: "Đại tiệc deal hot sắm ngay đồng hồ thông minh ưu đãi quà tặng kèm",
      chude: "Thiết bị thông minh",
    },
    {
      id: 5,
      img: "https://cdn.tgdd.vn/hoi-dap/1436557/Thumbnail/top-dien-thoai-tot-nhat-tam-gia-4-trieu-ban-nen-mua-thumb-1.jpg",
      title:
        "TOP 7 điện thoại tốt nhất tầm giá 2 triệu chất lượng siêu tốt tại TGDĐ",
      chude: "Thiết bị thông minh",
    },
    {
      id: 6,
      img: "https://cdn.tgdd.vn/hoi-dap/1447857/Thumbnail/an-toan-tiet-kiem-camera-ngoai-troi-3mp-tp-link-chua-toi-1-tgdd-thumb.jpg",
      title:
        "AN TOÀN - TIẾT KIỆM: Camera Ngoài Trời 3MP TP-link chưa tới 1 triệu",
      chude: "Thiết bị thông minh",
    },
    {
      id: 7,
      img: "https://cdn.tgdd.vn/hoi-dap/1447627/Thumbnail/alo-sam-ngay-dong-ho-thong-minh-garmin-cuc-xin-giam-dong-thumb.jpg",
      title: "ALO: Sắm ngay đồng hồ thông minh Garmin cực xịn giảm đồng loạt 35%",
      chude: "Thiết bị thông minh",
    },
  
    {
      id: 1,
      img: "https://cdn.tgdd.vn/hoi-dap/1448087/Thumbnail/cuong-sao-noi-voi-loat-deal-samsung-galaxy-watch4-giam-thumb.jpg",
      title: "Cưỡng sao nổi với loạt DEAL Samsung Galaxy Watch4 giảm tới 3 triệu",
      chude: "Thiết bị thông minh",
    },
    {
      id: 1,
      img: "https://cdn.tgdd.vn/hoi-dap/1450300/Thumbnail/cach-go-so-dien-thoai-tren-facebook-sieu-nhanh-chong-ban-thumb-1.jpg",
      title: "Cách gỡ số điện thoại trên Facebook siêu nhanh chóng bạn nên thử",
      chude: "Thiết bị thông minh",
    },
  ];

  
  export const dataNews24h = [
    {
      id: 1,
      image:
        "https://cdn.tgdd.vn/Files/2022/07/28/1451069/shopeepay_1280x720-300x200.jpg",
      title:
        "Nhập mã SPPMWG giảm 10% tối đa 100K khi thanh toán qua ví ShopeePay",
      time: "15 phút trước",
    },
    {
      id: 1,
      image:
        "https://cdn.tgdd.vn/Files/2022/08/04/1453231/samsung-galaxy-flex-mode_1280x720-300x200.jpg",
      title:
        "Liệu trải nghiệm chơi game trên Galaxy Z thế hệ mới sẽ được cải tiến hơn?",
      time: "27 phút trước",
    },
    {
      id: 1,
      image:
        "https://cdn.tgdd.vn/Files/2022/08/02/1452743/thumb3_800x450-300x200.jpg",
      title:
        "Nghe Đồn Là: Redmi 11 Prime 5G dùng Snapdragon 720G, sạc nhanh 33 W, giá 5 triệu (liên tục cập nhật)",
      time: "34 phút trước",
    },
    {
      id: 1,
      image:
        "https://cdn.tgdd.vn/Files/2022/08/04/1453215/ticketmaster-tgdd-1-2-3_1280x720-300x200.jpg",
      title:
        "TikTok, Ticketmaster ra tính năng giúp người dùng 'Gen Z' đặt vé sự kiện trên app",
      time: "1 giờ trước",
    },
    {
      id: 1,
      image:
        "https://cdn.tgdd.vn/Files/2022/07/06/1445325/cach-ngan-theo-doi-email-trong-gmail-08_800x450-300x200.jpg",
      title:
        "Cách ngăn theo dõi email trong Gmail đơn giản, nhanh chóng, tiện lợi dành cho bạn",
      time: "1 giờ trước",
    },
  ];
  